module.exports = __webpack_public_path__ + "media/carousel_images/Imagen2-ddf13e4c.png";